"use client";

import { useEffect, useRef, useState } from "react";

/**
 * スクロールで要素が画面内に入ったらフェードインさせるためのフック。
 * prefers-reduced-motion 有効時は監視自体を行わず、最終状態（表示済み）を返す。
 */
export function useScrollReveal<T extends HTMLElement>() {
  const ref = useRef<T>(null);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) {
      setIsVisible(true);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.unobserve(el);
        }
      },
      { threshold: 0.14 },
    );
    observer.observe(el);

    return () => observer.disconnect();
  }, []);

  return { ref, isVisible };
}
